export const ActionTypes = {
  SET_MALLS: 'SET_MALLS',
  SET_STORES: 'SET_STORES',
  SET_STORES_NEW_USER: 'SET_STORES_NEW_USER',
  SET_STORE_GROUPS: 'SET_STORE_GROUPS',
};
